import _axios from '@/plugins/axios';
import { useAxios } from '@vueuse/integrations/useAxios';

const ENDPOINT = '/v1/community/videochat/bar/uniqueRoomName';

const useLeaveBarChat = () => {
  function getEndpoint(uniqueRoomName: string) {
    return ENDPOINT.replace('uniqueRoomName', uniqueRoomName);
  }

  const useLeaveBarAxios = useAxios(ENDPOINT, { method: 'DELETE' }, _axios, { immediate: false });

  // Track pending requests to prevent duplicates
  let leaveRequestPromise: Promise<any> | null = null;

  async function leaveBarChat(uniqueRoomName: string) {
    // If there's already a pending request, return it instead of creating a new one
    if (leaveRequestPromise) {
      return leaveRequestPromise;
    }

    leaveRequestPromise = useLeaveBarAxios.execute(getEndpoint(uniqueRoomName), { method: 'DELETE' });

    try {
      return await leaveRequestPromise;
    } finally {
      leaveRequestPromise = null;
    }
  }

  return {
    leaveBarChat,
    ...useLeaveBarAxios
  };
};

export default useLeaveBarChat;
